import { render, staticRenderFns } from "./PhdProposalPc.vue?vue&type=template&id=07986bd9&scoped=true&"
import script from "./PhdProposalPc.vue?vue&type=script&lang=js&"
export * from "./PhdProposalPc.vue?vue&type=script&lang=js&"
import style0 from "./PhdProposalPc.vue?vue&type=style&index=0&id=07986bd9&prod&scoped=true&lang=scss&"
import style1 from "./PhdProposalPc.vue?vue&type=style&index=1&id=07986bd9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07986bd9",
  null
  
)

export default component.exports